import { useCallback, useMemo, useState } from 'react'

import { Input, Tooltip } from 'antd'
import { isArray, isFunction } from 'lodash'

import Loading from '../../shared/Loading'

const { Search } = Input

/** An option searched on what it is rather than on what it renders : a JSX label has nothing to match against. */
const getKeywords = item => isArray(item.keywords) ? item.keywords : [item.label, item.tooltip]

const SearchList = ({ selected, data = [], loading = false, maxHeight = 300, onSelectedChange }) => {
  const [search, setSearch] = useState('')

  const items = useMemo(() => {
    const items = isArray(data) ? data : []

    if (!search) {
      return items
    }

    return items.filter(item => getKeywords(item)
      .some(keyword => typeof keyword === 'string' && keyword.toLowerCase().includes(search)))
  }, [search, data])

  const renderItem = useCallback(item => {
    let body = ''
    let className = 'search-list-item'

    if (item.label) {
      body = <span>{item.label}</span>
    }

    if (item.value && isFunction(onSelectedChange)) {
      const isSelected = selected === item.value
      className += isSelected ? ' selected' : ''

      body = <div onClick={() => onSelectedChange(selected === item.value ? undefined : item.value)}> {body} </div>
    }

    if (item.tooltip) {
      body = <Tooltip title={item.tooltip} placement='right'> {body} </Tooltip>
    }

    return <li key={item.value ?? item.label} className={className}> {body} </li>
  }, [selected, onSelectedChange])

  return (
    <div className='search-list w-100 h-100'>
      <Search disabled={loading} onChange={e => setSearch(e.target.value.toLowerCase())} />
      <div className='overflow-y ant-list-border' style={{ maxHeight: maxHeight + 'px' }}>
        {loading ? (
          <Loading style={{ height: '100px' }} />
        ) : (
          <ul className='list-container'>
            {items.map(renderItem)}
          </ul>
        )}
      </div>
    </div>
  )
}

export default SearchList
